<div if.bind="usersReport.panelOpen" class="modal-overlay" click.trigger="usersReport.closePanel()">
  <div class="users-report-admin" click.trigger="$event.stopPropagation()">
    <div class="users-report-admin__header">
      <h3 class="users-report-admin__title">User report</h3>
      <button type="button" class="users-report-admin__close" click.trigger="usersReport.closePanel()" aria-label="Close"><span class="icon icon--close" aria-hidden="true"></span></button>
    </div>

    <div class="users-report-admin__body">
      <p class="users-report-admin__hint">
        Every registered user with how many saved searches they have and which email notifications they have on.
      </p>

      <div class="users-report-admin__toolbar">
        <span if.bind="!usersReport.loading" class="users-report-admin__count">${usersReport.rows.length} user${usersReport.rows.length === 1 ? '' : 's'}</span>
        <button type="button" class="login-btn login-btn--secondary" click.trigger="usersReport.load()" disabled.bind="usersReport.loading">Refresh</button>
      </div>

      <div if.bind="usersReport.error" class="users-report-admin__error">${usersReport.error}</div>
      <div if.bind="usersReport.loading" class="users-report-admin__status">Loading users&hellip;</div>

      <div if.bind="!usersReport.loading && usersReport.rows.length === 0 && !usersReport.error" class="users-report-admin__status">
        No registered users.
      </div>

      <div if.bind="!usersReport.loading && usersReport.rows.length > 0" class="users-report-admin__table-wrap">
        <table class="users-report-admin__table">
          <thead>
            <tr>
              <th>User</th>
              <th>Tier</th>
              <th class="users-report-admin__num">Saved searches</th>
              <th>Daily digest</th>
              <th>Saved searches</th>
              <th>Availability</th>
            </tr>
          </thead>
          <tbody>
            <tr repeat.for="row of usersReport.rows">
              <td>
                <div class="users-report-admin__user">
                  <span class="users-report-admin__name">${row.displayName || row.email}</span>
                  <span if.bind="row.displayName" class="users-report-admin__email">${row.email}</span>
                </div>
              </td>
              <td>${row.tier}</td>
              <td class="users-report-admin__num">${row.savedSearchCount}</td>
              <td>
                <span class="users-report-admin__flag ${row.digestOptIn ? 'users-report-admin__flag--on' : 'users-report-admin__flag--off'}">${row.digestOptIn ? 'On' : 'Off'}</span>
              </td>
              <td>
                <span class="users-report-admin__flag ${row.notifySavedSearches ? 'users-report-admin__flag--on' : 'users-report-admin__flag--off'}">${row.notifySavedSearches ? 'On' : 'Off'}</span>
                <span if.bind="row.notifySavedSearches" class="users-report-admin__sub">${row.savedSearchFrequency}</span>
              </td>
              <td>
                <span class="users-report-admin__flag ${row.notifyAvailability ? 'users-report-admin__flag--on' : 'users-report-admin__flag--off'}">${row.notifyAvailability ? 'On' : 'Off'}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
